import { defineStore } from "pinia";
import { ref, onMounted } from "vue";
import network from "@/utils/network";
import {
  OVERVIEW_THRESHOLD_SETTING_KEYS,
  HANDLE_WEEKEND_COLUMN_APPEARANCE,
} from "@/utils/const";

const axios = network.createAxiosInstance();

export const useOverviewThresholdSettingStore = defineStore(
  "overviewTresholdSetting",
  () => {
    const showWeekends = ref(false);
    const overallLoggedTimeComplianceErrorThreshold = ref(0);
    const projectLoggedTimeComplianceErrorThreshold = ref(0);

    const updateTresholdSetting = async (key, value) => {
      const response = await axios.put(
        `/v2/census/user/setting/ENTERPRISE/${key}`,
        {
          value,
        }
      );
      if (
        key ===
        OVERVIEW_THRESHOLD_SETTING_KEYS.OVERALL_LOGGED_TIME_COMPLIANCE_ERROR_THRESHOLD
      ) {
        overallLoggedTimeComplianceErrorThreshold.value = response.data;
      } else if (
        key ===
        OVERVIEW_THRESHOLD_SETTING_KEYS.PROJECT_LOGGED_TIME_COMPLIANCE_ERROR_THRESHOLD
      ) {
        projectLoggedTimeComplianceErrorThreshold.value = response.data;
      }
    };

    const fetchTresholdSetting = async (key) => {
      const response = await axios.get(
        `/v2/census/user/setting/ENTERPRISE/${key}`
      );

      if (
        key ===
        OVERVIEW_THRESHOLD_SETTING_KEYS.OVERALL_LOGGED_TIME_COMPLIANCE_ERROR_THRESHOLD
      ) {
        overallLoggedTimeComplianceErrorThreshold.value = response.data
          ? response.data
          : 0;
      } else if (
        key ===
        OVERVIEW_THRESHOLD_SETTING_KEYS.PROJECT_LOGGED_TIME_COMPLIANCE_ERROR_THRESHOLD
      ) {
        projectLoggedTimeComplianceErrorThreshold.value = response.data
          ? response.data
          : 0;
      }
    };

    const updateShowWeekends = async (value) => {
      const response = await axios.put(
        `/v2/census/user/setting/ENTERPRISE/${HANDLE_WEEKEND_COLUMN_APPEARANCE.OVERVIEW_LOGGED_TIME_TAB}`,
        {
          value,
        }
      );
      showWeekends.value = response.data;
    };

    const fetchShowWeekends = async () => {
      const response = await axios.get(
        `/v2/census/user/setting/ENTERPRISE/${HANDLE_WEEKEND_COLUMN_APPEARANCE.OVERVIEW_LOGGED_TIME_TAB}`
      );
      showWeekends.value = response.data;
    };

    onMounted(() => {
      fetchTresholdSetting(
        OVERVIEW_THRESHOLD_SETTING_KEYS.OVERALL_LOGGED_TIME_COMPLIANCE_ERROR_THRESHOLD
      );
      fetchTresholdSetting(
        OVERVIEW_THRESHOLD_SETTING_KEYS.PROJECT_LOGGED_TIME_COMPLIANCE_ERROR_THRESHOLD
      );
      fetchShowWeekends();
    });

    return {
      overallLoggedTimeComplianceErrorThreshold,
      projectLoggedTimeComplianceErrorThreshold,
      updateTresholdSetting,

      showWeekends,
      updateShowWeekends,
    };
  }
);
